/**
 * Geld (SPEC §4.3). Bedragen zijn **eurocenten als integer**, nergens floats.
 */

/**
 * Het hoogste bedrag dat Mollie per SEPA-incasso toestaat (goedkeuring van
 * 12 oktober 2026). Een jaarbijdrage daarboven krijgt in januari een
 * betaalverzoek in plaats van een incasso; een held kan zelf niet meer kiezen.
 */
export const MAXIMUM_INCASSO_CENT = 100_000;

/** Kan dit bedrag via de jaarlijkse incasso? */
export function viaIncasso(cent: number): boolean {
  return cent <= MAXIMUM_INCASSO_CENT;
}

/** `10000` → `€ 100,-`; `2550` → `€ 25,50`. Met een vaste spatie na het euroteken. */
export function alsEuro(cent: number): string {
  if (!Number.isInteger(cent)) throw new Error(`Geen heel aantal centen: ${cent}`);
  const teken = cent < 0 ? '-' : '';
  const heel = Math.trunc(Math.abs(cent) / 100);
  const rest = Math.abs(cent) % 100;
  const duizendtallen = heel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalen = rest === 0 ? '-' : String(rest).padStart(2, '0');
  return `${teken}€ ${duizendtallen},${decimalen}`;
}

/** Als `alsEuro`, maar altijd met twee decimalen: voor tabellen en Mollie-omschrijvingen. */
export function alsEuroExact(cent: number): string {
  return alsEuro(cent).replace(',-', ',00');
}

/** Een invoerveld ("100", "100,50", "€ 100") naar centen; `null` als het geen bedrag is. */
export function uitInvoer(tekst: string): number | null {
  const schoon = tekst.replace(/[€\s.]/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(schoon)) return null;
  const [heel, rest = ''] = schoon.split('.');
  return Number(heel) * 100 + Number(rest.padEnd(2, '0'));
}
